<div class="main-section">
  <!-- <div class="left-container" *ngIf="edit">
    <h2>List of components</h2>

    <div
      class="component-list"
      cdkDropList
      [cdkDropListData]="componentList"
      [cdkDropListConnectedTo]="connectedDropLists"
      id="Comlist"
    >
      <div class="items" cdkDrag *ngFor="let item of componentList; index as i">
        <img [src]="item.imgUrl" [alt]="item.title" />
        <h3>{{ item.title }}</h3>
      </div>
    </div>
  </div> -->

  <div class="dashboard-container">
    <div class="btn-action">
      <button class="btn-button" *ngIf="!edit" (click)="editLayout()">Edit Layout</button>
      <button class="btn-button" *ngIf="edit" (click)="saveLayout()">Update Layout</button>
      <button class="btn-button" *ngIf="edit" (click)="cancel()">Cancel</button>
    </div>

    <div>
      <div
        class="layouts"
        *ngFor="let column of defaultLayout; trackBy: trackByColumn"
        cdkDropList
        [cdkDropListData]="column.sections"
        [cdkDropListConnectedTo]="connectedDropLists"
        [id]="column.id"
        [class.column]="edit"
        (cdkDropListDropped)="drop($event)"
      >
        <small class="delete-column" *ngIf="edit" (click)="removeColumn(column)">
          <!-- SVG for delete column -->
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 32 32">
            <g>
              <path fill="#f44336" d="M16 2c-18.5.6-18.5 27.4 0 28 18.5-.6 18.5-27.4 0-28z"></path>
              <path fill="#eeeeee"
                d="m17.4 16 4.2-4.2c.9-.9-.5-2.3-1.4-1.4L16 14.6l-4.2-4.2c-.9-.9-2.3.5-1.4 1.4l4.2 4.2-4.2 4.2c-.9.9.5 2.3 1.4 1.4l4.2-4.2 4.2 4.2c.9.9 2.3-.5 1.4-1.4z">
              </path>
            </g>
          </svg>
        </small>

        <div class="kpi-cards-wrapper">
          <div
            class="kpi-card"
            *ngFor="let section of column.sections; trackBy: trackBySection"
            cdkDrag
            [cdkDragDisabled]="!edit"
          >
            <small class="delete" *ngIf="edit" (click)="deleteSection(section, column)">
              <!-- delete icon -->
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 492 492">
                <path fill="#8f8f8f"
                  d="M300.188 246 484.14 62.04c5.06-5.064 7.852-11.82 7.86-19.024 0-7.208-2.792-13.972-7.86-19.028L468.02 7.872C462.952 2.796 456.196.016 448.984.016c-7.2 0-13.956 2.78-19.024 7.856L246.008 191.82 62.048 7.872C56.988 2.796 50.228.016 43.02.016c-7.2 0-13.96 2.78-19.02 7.856L7.872 23.988c-10.496 10.496-10.496 27.568 0 38.052L191.828 246 7.872 429.952C2.808 435.024.02 441.78.02 448.984c 0 7.204 2.788 13.96 7.852 19.028l16.124 16.116c5.06 5.072 11.824 7.856 19.02 7.856 7.208 0 13.968-2.784 19.028-7.856l183.96-183.952 183.952 183.952c5.068 5.072 11.824 7.856 19.024 7.856h.008c7.204 0 13.96-2.784 19.028-7.856l16.12-16.116c5.06-5.064 7.852-11.824 7.852-19.028 0-7.204-2.792-13.96-7.852-19.028L300.188 246z">
                </path>
              </svg>
            </small>

            <div class="custom-placeholder" *cdkDragPlaceholder></div>

          <ng-container [ngSwitch]="section.settings?.componentName">

            <app-total-land-property
              *ngSwitchCase="ComponentEnum.TotalLandProperty">
            </app-total-land-property>

            <app-average-land-area
              *ngSwitchCase="ComponentEnum.AverageLandArea">
            </app-average-land-area>

            <app-land-development-rate
              *ngSwitchCase="ComponentEnum.LandDevelopmentRate">
            </app-land-development-rate>

             <app-residential-land-supply5-years
              *ngSwitchCase="ComponentEnum.ResidentialLandSupply5Years">
            </app-residential-land-supply5-years>

             <app-independent-properties
              *ngSwitchCase="ComponentEnum.IndependentProperties">
            </app-independent-properties>

             <app-governmental-properties
              *ngSwitchCase="ComponentEnum.GovernmentalProperties">
            </app-governmental-properties>

             <app-house-villa-projects
              *ngSwitchCase="ComponentEnum.HouseVillaProjects">
            </app-house-villa-projects>

            <div *ngSwitchDefault> </div>

          </ng-container>
          </div>
        </div>
      </div>

      <!-- Add Column Button -->
      <div class="btn-action" *ngIf="edit">
        <button class="btn-button" (click)="addColumn()">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 426.667 426.667">
            <path fill="#119817"
              d="M405.332 234.668h-384C9.559 234.668 0 225.109 0 213.332 0 201.559 9.559 192 21.332 192h384c11.777 0 21.336 9.559 21.336 21.332 0 11.777-9.559 21.336-21.336 21.336z">
            </path>
            <path fill="#119817"
              d="M213.332 426.668c-11.773 0-21.332-9.559-21.332-21.336v-384C192 9.559 201.559 0 213.332 0c11.777 0 21.336 9.559 21.336 21.332v384c0 11.777-9.559 21.336-21.336 21.336z">
            </path>
          </svg>
          Add Section
        </button>
      </div>
    </div>
  </div>
</div>
